import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import api from '../../api/api'

const Valid = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [confirmMsg, setConfirmMsg] = useState("");

  const params = useParams()
  let tokenToValid = params.ToValid

  useEffect(() => {
    const Validate = async () => {
      try {
        const response = await api.get(`/valid-account/${tokenToValid}`);
        if (response.data.type && response.data.type === "success") {
          setConfirmMsg(response.data.message)
          setStatus("success");
        } else {
          setStatus("error");
        }
      } catch (e) {
        setStatus("error");
      }
    }
    Validate()
  }, [tokenToValid])

  return (
    <main className="auth-page auth-reset-page">
      <div className="auth-shell auth-shell-compact">
        <section className="auth-form-panel auth-status-panel">
          <div className="auth-form-content auth-reset-content auth-status-content">
            {status === "loading" && (
              <>
                <i className="fas fa-circle-notch fa-spin auth-status-icon" aria-hidden="true" />
                <p>{t('checking_link', 'Validation de votre compte en cours…')}</p>
              </>
            )}

            {status === "success" && (
              <>
                <span className="auth-status-icon auth-status-icon-success">
                  <i className="fas fa-check-circle" aria-hidden="true" />
                </span>
                <h2>{t('account_confirmed', 'Votre compte est confirmé')}</h2>
                {confirmMsg && <p>{confirmMsg}</p>}
                <Link to="/" className="auth-primary-button auth-status-link">
                  <i className="fas fa-arrow-right" />
                  <span>{t('sign_in', 'Login')}</span>
                </Link>
              </>
            )}

            {status === "error" && (
              <>
                <span className="auth-status-icon auth-status-icon-danger">
                  <i className="fas fa-exclamation-triangle" aria-hidden="true" />
                </span>
                <h2>{t('error_link_account', 'Ce lien de confirmation est invalide ou a expiré.')}</h2>
                <Link to="/" className="auth-primary-button auth-status-link">
                  <i className="fas fa-arrow-left" />
                  <span>{t('sign_in', 'Login')}</span>
                </Link>
              </>
            )}
          </div>
        </section>
      </div>
    </main>
  )
}

export default Valid
